import React from 'react';
import PropTypes from 'prop-types';
import humanize from 'humanize-plus';
import { kebabCase } from 'lodash';
const JobsRow = props => {
  const {
    data: {
      id,
      formID,
      jobNumber,
      name
    },
    index,
    onClick
  } = props;
  const handleClick = () => onClick(id, formID);
  return /*#__PURE__*/React.createElement("tr", {
    onClick: handleClick,
    className: `t-jr-${index}`
  }, /*#__PURE__*/React.createElement("td", {
    className: `t-jr-job-number t-jr-job-number-${kebabCase(jobNumber)}`
  }, jobNumber), /*#__PURE__*/React.createElement("td", null, name ? humanize.truncate(name, 50) : undefined));
};
JobsRow.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.shape({
    formID: PropTypes.string,
    id: PropTypes.string.isRequired,
    jobNumber: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
export default JobsRow;